module.exports = __webpack_public_path__ + "img/list-tick.56ac1c21.svg";